// Frontend-managed spin wheel coupons (fixed set)
const spinCoupons = [
  { text: "🎁 15% off your next pizza!", text_ar: "🎁 خصم 15% على بيتزاك القادمة!", code: "PIZZA15", type: "percentage", discount: 15, minAmount: 5 },
  { text: "🚚 Free delivery within 5km!", text_ar: "🚚 توصيل مجاني داخل 5 كيلومتر!", code: "FREEDEL", type: "delivery", discount: 1.5, minAmount: 8 },
  { text: "💰 1 OMR off your order!", text_ar: "💰 خصم 1 ريال من طلبك!", code: "SPIN1OFF", type: "fixed", discount: 1, minAmount: 6 },
  { text: "💰 2 OMR off your order!", text_ar: "💰 خصم 2 ريال من طلبك!", code: "SPIN2OFF", type: "fixed", discount: 2, minAmount: 10 },
  { text: "💰 4 OMR off your order!", text_ar: "💰 خصم 4 ريال من طلبك!", code: "SPIN4OFF", type: "fixed", discount: 4, minAmount: 15 },
];

export default spinCoupons;
